import { createApp } from 'vue';
import App from './App';
const appMain = createApp(App);

import router from './router';
appMain.use(router);
import './router/modules/permissions';

import store from './store';
appMain.use(store);

import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css';

// 公共js、css引入
import './utils/JsImport';
import './utils/CssImport';

// svg-icon
import SvgInit from '@/icons';
SvgInit(appMain);

import { initAppPlugins } from '@/utils/js/initVariable';
initAppPlugins(appMain);

// import 'amfe-flexible';
import './utils/js/Rem-plug/init';

appMain.mount('#app');